import { render, staticRenderFns } from "./LandingContentBox.vue?vue&type=template&id=0f040571&scoped=true"
import script from "./LandingContentBox.vue?vue&type=script&lang=ts"
export * from "./LandingContentBox.vue?vue&type=script&lang=ts"
import style0 from "./LandingContentBox.vue?vue&type=style&index=0&id=0f040571&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f040571",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f040571')) {
      api.createRecord('0f040571', component.options)
    } else {
      api.reload('0f040571', component.options)
    }
    module.hot.accept("./LandingContentBox.vue?vue&type=template&id=0f040571&scoped=true", function () {
      api.rerender('0f040571', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Landing/LandingContentBox.vue"
export default component.exports